import { ReactNode } from 'react';
import { Drawer, Modal as AntModal } from 'antd';
import { Grid } from 'antd';
import { ModalHeader } from './components';
import { useTheme } from '@src/theme';

const { useBreakpoint } = Grid;
interface ModalProps {
    isOpen: boolean;
    title?: string;
    headerIcon?: ReactNode;
    content: ReactNode;
    footer?: ReactNode;
    width?: number;
    headerClassName?: string;
    onClose: () => void;
}

export function Modal({
    isOpen,
    title,
    headerIcon,
    content,
    footer,
    width,
    headerClassName,
    onClose,
}: ModalProps) {
    const { theme } = useTheme();
    const screens = useBreakpoint();
    const isBelowSm = !screens.sm;

    return isBelowSm ? (
        <Drawer
            open={isOpen}
            onClose={onClose}
            closeIcon={null}
            placement="bottom"
            height="auto"
            className="rounded-t-lg flex flex-col max-h-[90vh]"
            rootClassName="custom-drawer-height"
            styles={{
                body: {
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'auto',
                },
            }}
        >
            <ModalHeader
                title={title}
                headerIcon={headerIcon}
                onClose={onClose}
                className={`mb-4 px-4 ${headerClassName || ''}`}
            />
            <div className="flex-grow overflow-auto px-4 pb-4">{content}</div>
            {footer && (
                <div className="sticky bottom-0 h-8 z-10  border-t pt-2 px-4">
                    {footer}
                </div>
            )}
        </Drawer>
    ) : (
        <AntModal
            open={isOpen}
            closeIcon={null}
            footer={footer ?? null}
            centered
            width={width}
            style={{
                border: `solid 1px ${theme.semantic.border}`,
                borderRadius: '8px',
            }}
            styles={{
                mask: {
                    backdropFilter: 'blur(2px)',
                    backgroundColor: 'rgba(25, 28, 30, 0.3)',
                },
                body: {
                    padding: 0,
                    borderRadius: '0.5rem',
                    maxHeight: '80vh',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                },
                content: {
                    backgroundColor: theme.semantic.surface,
                },
                footer: {
                    borderTop: `solid 1px ${theme.semantic.border}`,
                    paddingTop: '10px',
                    paddingLeft: 16,
                    paddingRight: 16,
                },
            }}
            className="custom-modal"
        >
            <ModalHeader
                title={title}
                headerIcon={headerIcon}
                onClose={onClose}
                className={`mb-4 px-4 ${headerClassName || ''}`}
            />
            <div
                className="flex-grow overflow-auto px-4 pb-2"
                style={{ maxHeight: 'calc(80vh - 60px)' }}
            >
                {content}
            </div>
        </AntModal>
    );
}
